import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TranslateModule } from '@ngx-translate/core';
import { AddTemplateComponent } from './add-template.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        TranslateModule.forChild(),
    ],
    declarations: [
        AddTemplateComponent,
    ],
    exports: [
        AddTemplateComponent
    ]
})
export class AddTemplateModule { }
